export default __webpack_public_path__ + "static/media/brand.0396232d.png";